<span class="filter-title">{{ filter?.title }}: </span>
<span class="filter-options">
  <span *ngFor="let option of filter?.options" class="color" [style.background]="option?.colorHex"></span>
</span>
